// 支付相关翻译

export const payment = {
    selectMethod: 'Select Payment Method',
    orderSummary: 'Order Summary',
    choosePaymentMethod: 'Choose your preferred payment method',
    creditCard: 'Credit/Debit Card',
    creditCardDescription: 'Pay securely with your credit or debit card via Stripe',
    paypalDescription: 'Pay with your PayPal account or PayPal balance',
    securityNote: 'Your payment information is encrypted and secure',
    processing: 'Processing payment...',
    paymentFailed: 'Payment failed. Please try again.',
    paymentCancelled: 'Payment was cancelled.',
    invalidPaymentMethod: 'Invalid payment method selected.',
    networkError: 'Network error. Please check your connection and try again.',
    paypalPayment: 'PayPal Payment',
    loadingPayPal: 'Loading PayPal...',
    paypalSecurityNote: 'Your payment is processed securely by PayPal',
    
    // 支付状态轮询翻译
    poller: {
      success: 'Payment completed successfully',
      processing: 'Payment confirmed, processing credits...',
      failed: 'Payment failed',
      unknown: 'Unknown payment status',
      error: 'Error checking payment status',
      network_error: 'Network error while checking payment status',
      starting: 'Starting payment verification...',
      timeout: 'Payment verification timeout',
      quickSuccess: 'Payment successful! Processing your credits...',
      // 新增的翻译键
      offline: 'Network connection lost',
      auth_error: 'Authentication failed',
      not_found: 'Order not found',
      server_error: 'Server error, retrying...',
      invalid_data: 'Invalid response data',
      invalid_status: 'Invalid payment status',
      invalid_order: 'Invalid order ID'
    },
    
    // 支付成功页面翻译
    success: {
      title: 'Payment Successful!',
      message: 'Thank you for your payment. Your transaction has been completed successfully.',
      description: 'You can now enjoy all the premium features.',
      continue: 'Continue to Dashboard'
    },
    
    // 支付回调页面翻译
    callback: {
      cancelled: 'Payment was cancelled by user',
      missingParams: 'Missing payment parameters',
      success: 'Payment completed successfully',
      failed: 'Payment processing failed',
      timeout: 'Payment is still being processed. Please check your account later.',
      verificationFailed: 'Payment verification failed',
      error: 'Failed to verify payment. Please contact support.',
      transactionId: 'Transaction ID',
      status: 'Status',
      quickSuccess: 'Payment successful! Your credits are being processed and will be available shortly.',
      
      processing: {
        title: 'Processing Payment',
        message: 'Please wait while we verify your payment...',
        webhook: 'Payment completed, processing your order...'
      },
      
      quickSuccessDetails: {
        title: 'Payment Successful!',
        processing: 'Credits are being added to your account...',
        continue: 'Continue to Dashboard'
      },
      
      successDetails: {
        title: 'Payment Successful!',
        message: 'Thank you for your payment. Your transaction has been completed successfully.',
        description: 'You can now enjoy all the premium features.',
        continue: 'Continue to Dashboard'
      },
      
      cancelledDetails: {
        title: 'Payment Cancelled',
        message: 'Your payment was cancelled. No charges have been made to your account.',
        description: 'You can try again or choose a different payment method.',
        continue: 'Back to Pricing'
      },
      
      errorDetails: {
        title: 'Payment Error',
        message: 'Too many errors occurred while checking payment status.',
        description: 'Please try again or contact support if the problem persists.'
      },
      
      timeoutDetails: {
        title: 'Payment Processing',
        description: 'Your payment may still be processing. Please check your account in a few minutes or contact support if needed.',
        continue: 'Go to Dashboard'
      },
      
      failedDetails: {
        title: 'Payment Failed',
        description: 'Please try again or contact our support team if the problem persists.',
        continue: 'Back to Pricing'
      }
    }
  };
